import { connectServiceOrderItemLabel } from './connectServiceOrderItemLabel';
import { ServiceOrderItemLabel as ServiceOrderItemLabelPure } from './ServiceOrderItemLabel';

export const ServiceOrderItemLabel = connectServiceOrderItemLabel(ServiceOrderItemLabelPure);
